import React from 'react'

import { Tag } from '@fourthwall/components'

import { STATUSES } from './consts'
import type { Props } from './types'

const PromotionStatusTagComponent = ({ promotion, size }: Props) => (
  <Tag
    label={STATUSES[promotion.status.type]?.label}
    appearance={STATUSES[promotion.status.type]?.appearance}
    size={size}
  />
)

export const PromotionStatusTag = React.memo(PromotionStatusTagComponent)
